import { environment } from '../../../../environments/environment';
import { ASIProductColumnsV2, ResponseColumnsASI, ResponseColumnsASIV2 } from './view.model';
import { ReviewColumnsASI } from './review.model';
// control to convert api get data to table
export class ViewASIControl {
  /**
   * @arg capabilitiesList to append all the list of capabilities from obtained from the api
   */
  capabilitiesList;
  /**
  * @arg apiRequest to store parsed asi capabilities payload
  */
  apiRequest: Array<object>;
  /**
   * @arg dataSource the table data to show the received asi capabilities
   */
  dataSource: Array<object>;
  /**
   * @arg apiData the api response for the asi capabilities to be converted
   */
  apiData: Array<object>;
  /**
   *@arg ResponseASICOLUMNS
   **/
  public responseASICOLUMNS: string[];
  constructor(private activePortal: string, private step?: string) {
    this.capabilitiesList = [];
    this.apiRequest = [];
    this.dataSource = [];
    this.activePortal = activePortal;
    this.responseASICOLUMNS = this.activePortal === 'svppv2' ? ResponseColumnsASIV2 : ResponseColumnsASI;
  }
  /**
   * @method getApiEndpoint returns the end point to call the asi capabilities
   */
  public get getApiEndpoint(): string {
    return this.activePortal === 'svppv2' ? environment.ProductCatalog.apis.getAsiV2 : environment.ProductCatalog.apis.getAsi;
  }
  /**
   * @method getParams returns the params for the api call
   * @arg state state of the records submitted or approved
   */
  public getParams(state: string): object {
    return state === 'submitted' ?
      { type: 'getasi', params: { review: state } } : { type: 'getasi' };
  }
  /**
   * @method setData sets the data and starts to parse the data
   */
  public setData(data: Array<object>): void {
    this.apiData = data;
    this.ParseData();
  }
  /**
   * @method ParseData parses the data to table data source
   */
  private ParseData(): void {
    this.apiData.forEach(asi => {
      this.convertToDataSource(asi);
    });
  }
  /**
   * @method convertToDataSource converts each record and makes it linear json
   * @arg asi each asi record
   */
  private convertToDataSource(asi: object): void {
    this.dataSource.push(Object.assign(this.getCapabilities(asi), this.getFixedValues(asi)));
  }
  /**
   * @method getCapabilities returns the capabilities columns values from the asi record
   * @arg asi asi record
   */
  private getCapabilities(asi): object {
    let capabilities: object = {};
    const apiCapabilities = asi['capabilities'];
    if (this.step === 'asi-product-map') {
      return { capabilities: apiCapabilities };
    }
    if (!!apiCapabilities) {
      apiCapabilities.forEach(capability => {
        const capabilityName = this.activePortal === 'svppv2' ? capability : Object.keys(capability)[0];
        this.activePortal === 'svppv2' ? capabilities[capabilityName] = true : capabilities = Object.assign(capabilities, capability);
        if (!(this.capabilitiesList.indexOf(capabilityName) > -1)) {
          this.capabilitiesList.push(capabilityName);
        }
      });
    }
    return capabilities;
  }
  /**
   * @method getFixedValues returns the fixed columns values from the asi record
   * @arg asi asi record
   */
  private getFixedValues(asi: object): object {
    const parsedData = {};
    this.responseASICOLUMNS.forEach(key => {
      parsedData[key] = key === 'mpc' ? asi[key][0] : asi[key];
    });
    Object.assign(parsedData, { select: 'checkbox' });
    if (this.step === 'asi-product-map') {
      parsedData['productIds'] = asi['productIds'];
    }
    return parsedData;
  }
  /**
   * @method getTableData returns the table data source
   */
  getTableData(): Array<object> {
    return this.dataSource;
  }
  /**
  * @method getColumns returns the column names
  **/
  public getColumns(reviewApproved: boolean): Array<string> {
    if (!this.responseASICOLUMNS.includes('select')) { this.responseASICOLUMNS.unshift('select'); }
    if (reviewApproved) { this.responseASICOLUMNS.shift(); }
    return [...this.responseASICOLUMNS, ...this.capabilitiesList];
  }
  /**
  * @method getColumnsProductMap returns the columns to be displayed for the asi product mapping component
  **/
  public getColumnsProductMap(addCheckbox: boolean): Array<string> {
    if (!ASIProductColumnsV2.includes('select')) { ASIProductColumnsV2.unshift('select'); }
    if (!addCheckbox) { ASIProductColumnsV2.shift(); }
    return [...ASIProductColumnsV2];
  }
  /**
  * @method getApiRequest returns the api request
  * @arg reviewAction should contains the approval or rejected related flag as string
  * @arg selections should contains selected asi product details
  * @returns apiRequest should contains all the prased asiCapabilities ID's and status as an object[]
  **/
  public getApiRequest(reviewAction: string, selections: Array<object>): object[] {
    this.apiRequest = [];
    selections.forEach(item => {
      this.apiRequest.push(this.getCapabilitieID(reviewAction, item));
    });
    return this.apiRequest;
  }
  /**
  * @method mapASIProductsRequest returns the api request for map asi product request
  * @arg selections should contains selected asi product details
  **/
  public mapASIProductsRequest(selections: Array<object>): object {
    this.apiRequest = [];
    selections.forEach(item => {
      item['mpc'] = !!item['mpc'] && typeof item['mpc'] === 'string' ? [item['mpc']] : [];
      delete item['select'];
      delete item['_id'];
      this.apiRequest.push(item);
    });
    return this.apiRequest;
  }
  /**
   * @method getCapabilitieID parse the getCapabilitieID values from the asi record
   * @arg reviewAction should contains the approval or rejected related flag as string
   * @arg item  should contains a asiCapabilitiy prodct as object
   * @returns parsedData contains the parsed  asiCapability ID and status as an object
   */
  private getCapabilitieID(reviewAction: string, item: object): object {
    const parsedData = {};
    ReviewColumnsASI.forEach(key => {
      parsedData[key] = key === 'asiCapabilityId' ? item['id'] : reviewAction;
    });
    return parsedData;
  }
  /**
  * @method getReviewApiEndpoint returns the end point to call the approve endpoint for asi, submit endpoint for asi product mapping
  */
  public get getReviewApiEndpoint(): string {
    if (this.activePortal === 'svppv2') {
      return (this.step === 'asi-product-map') ? environment.ProductCatalog.apis.asiv2 : environment.ProductCatalog.apis.approveAsiV2;
    } else {
      return (this.step === 'asi-product-map') ? environment.ProductCatalog.apis.asi : environment.ProductCatalog.apis.approveAsi;
    }
  }
  /**
  * @method getApitype returns api type based on step default is approve
  **/
  public get getApiType(): object {
    return { type: this.step === 'asi-product-map' ? 'asi-product-map' : 'approve-asi' };
  }
}
